import { createContext } from 'react';

import type { DictationRuntime } from './types';

export const DictationRuntimeContext = createContext<DictationRuntime | null>(null);
